import styled from 'styled-components'
import { Spacing, Colors, Shadows } from 'cio-design-library/design-tokens'
import { ButtonV2 } from 'builder/components/Button'
import Media from 'builder/styles/media'

type Props = {
  $isDarkBackground?: boolean
  $isFooterShadowVisible?: boolean
}

export const FooterContainer = styled.div<Props>`
  box-shadow: ${({ $isFooterShadowVisible }) =>
    $isFooterShadowVisible ? Shadows.lightWithBorderShadowMid : 'none'};
  transition: box-shadow 0.2s ease-out;
  padding: ${Spacing.S} 36px ${Spacing.M};
  display: flex;
  gap: ${Spacing['2XS']};
  flex-wrap: wrap;
  background-color: ${props => (props.$isDarkBackground ? Colors.Neutral100 : Colors.White)};
  border-radius: ${Spacing.XS} ${Spacing.XS} 0 0;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;

  ${Media.Phone`
    padding: ${Spacing.XS} 20px ${Spacing.M};
  `}
`

export const DownloadButton = styled(ButtonV2)`
  flex: 1;
`

export const CustomizeButton = styled(ButtonV2)`
  flex: 0 0 100%;
`
